// extracted by mini-css-extract-plugin
export default {"select_locale":"DrawerApp_select_locale__vATVL","flags":"DrawerApp_flags__i-x3K","header_mobile":"DrawerApp_header_mobile__bygo4","header_web":"DrawerApp_header_web__sSKpP"};